<main class="container" id="main">
    <div class="container__inner">
        <h1 i18n="@@scope-app-title">Scope Hub</h1>
        <div class="grid grid--home">
            <div class="card-main grid__item">
                <app-scope-card class="flex"></app-scope-card>
            </div>

            <div class="sidebar grid__item">
                <div class="full-width" *ngIf="cardItems$ | async as cardItems;">
                    <ng-container *ngIf="authService.isLoggedIn() && authService.isSuperAdmin()">
                        <riege-card class="margin-bottom--base" [data]="cardItems[2]" data-testid="tenants"></riege-card
                        ><!-- tenants -->
                    </ng-container>

                    <ng-container *ngTemplateOutlet="showCommunityMap ? communityMap : supportCards"></ng-container>

                    <ng-template #communityMap>
                        <riege-card [data]="cardItems[3]" data-testid="community-map"></riege-card
                        ><!-- community-map -->
                    </ng-template>

                    <ng-template #supportCards>
                        <riege-card
                            class="margin-bottom--base"
                            [data]="cardItems[0]"
                            data-testid="status-page"></riege-card
                        ><!-- status-page -->
                        <riege-card [data]="cardItems[1]" data-testid="knowledge-base"></riege-card
                        ><!-- knowledge-base -->
                    </ng-template>
                </div>
            </div>

            <ng-container *ngIf="showExchangeCalculator">
                <app-exchange-rate-calculator class="calculator"></app-exchange-rate-calculator>
            </ng-container>

            <ng-container *ngIf="hasPosts()">
                <div
                    class="blog flex flex-direction--column"
                    aria-labelledby="blog"
                    *ngIf="hasBlogItems()"
                    [ngClass]="hasReleaseItems() ? 'grid--two-thirds-desktop' : 'grid--three-thirds-desktop'">
                    <h2 id="blog" i18n="@@card-headline-blog">Latest blog entries</h2>
                    <div class="blog__inner flex flex-grow-shrink-auto">
                        <riege-news
                            class="flex"
                            [feed]="'blog'"
                            [count]="hasReleaseItems() ? 2 : 3"
                            (hasPosts)="hasBlogItems.set($event)"
                            data-testid="blog-news"></riege-news>
                    </div>
                </div>

                <div
                    class="release flex flex-direction--column"
                    aria-labelledby="release"
                    *ngIf="hasReleaseItems()"
                    [ngClass]="hasBlogItems() ? 'grid--one-third-desktop' : 'grid--three-thirds-desktop'">
                    <h2 id="release" i18n="@@card-headline-release">Release report</h2>
                    <riege-news
                        class="flex flex-grow-shrink-auto"
                        [feed]="'release-reports'"
                        [count]="hasBlogItems() ? 1 : 3"
                        (hasPosts)="hasReleaseItems.set($event)"
                        data-testid="release-reports"></riege-news>
                </div>
            </ng-container>
        </div>
    </div>
</main>
<!-- container-->
